import React from "react"
import NavBar from "./general/nav_bar"
import MainImage from "./general/home/carousel"
import Info from "./general/home/info"
import FeaturedProducts from "./general/home/featured_products"
import Footer from "./general/footer"
import MainProduct from './general/home/main_product'

export default function HomePage(){

    return(
        <>
            <MainImage/>
            <Info/>
            <FeaturedProducts/>
            <MainProduct/>
        </>
    )
}